import { Head } from '~/components/shared/Head';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { REGISTER_INSTAGRAM_ACCOUNT } from '~/services';
import { Rings } from 'react-loader-spinner';

const IGSuccess = () => {
  const location = useLocation();
  const [registerInstagramAccount] = useMutation(REGISTER_INSTAGRAM_ACCOUNT);
  const navigate = useNavigate();

  useEffect(() => {
    const agentId = sessionStorage.getItem('instagram_agent_id');
    // const params = new URLSearchParams(location.hash.slice(1));
    //  const accessToken = params.get('access_token');
    // const longLivedToken = params.get('long_lived_token');
    const params = new URLSearchParams(location.search); // Cambiado de location.hash a location.search

    const code = params.get('code');
    const params_agent_id = params.get('state');

    registerInstagramAccount({
      variables: {
        data: {
          agent_id: params_agent_id || agentId,
          // access_token: accessToken,
          // long_live_access_token: longLivedToken || accessToken,
          code: code,
        },
      },
      onCompleted: () => {
        sessionStorage.removeItem('instagram_agent_id');
        navigate(`/agent/${agentId}/integrations/instagram`);
      },
    });
  }, [location]);

  return (
    <div className="mx-auto mt-16 flex w-full max-w-[1024px] justify-center rounded-3xl ">
      <Head title="Instagram Connection" />
      <Rings
        height="160"
        width="160"
        radius={4}
        color={'#ff8270'}
        ariaLabel="rings-loading"
        wrapperStyle={{}}
        visible={true}
      />
    </div>
  );
};

export default IGSuccess;
